var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.totalPages > 1
    ? _c("div", [
        _c(
          "ul",
          { staticClass: "pagination" },
          [
            _c("li", { staticClass: "pagination-item" }, [
              _c("input", {
                attrs: {
                  type: "button",
                  disabled: _vm.isInFirstPage,
                  "aria-label": "Go to first page ",
                  value: "<<",
                },
                on: { click: _vm.onClickFirstPage },
              }),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-item" }, [
              _c("input", {
                attrs: {
                  type: "button",
                  disabled: _vm.isInFirstPage,
                  "aria-label": "Go to previous page ",
                  value: "<",
                },
                on: { click: _vm.onClickPreviousPage },
              }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.pages, function (page) {
              return _c("li", { staticClass: "pagination-item" }, [
                _c("input", {
                  class: { active: _vm.isPageActive(page.name) },
                  attrs: {
                    type: "button",
                    disabled: page.isDisabled,
                    value: page.name,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickPage(page.name)
                    },
                  },
                }),
              ])
            }),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-item" }, [
              _c("input", {
                attrs: {
                  type: "button",
                  disabled: _vm.isInLastPage,
                  "aria-label": "Go to next page ",
                  value: ">",
                },
                on: { click: _vm.onClickNextPage },
              }),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-item" }, [
              _c("input", {
                attrs: {
                  type: "button",
                  disabled: _vm.isInLastPage,
                  "aria-label": "Go to last page ",
                  value: ">>",
                },
                on: { click: _vm.onClickLastPage },
              }),
            ]),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }